/* ============================================================
   Suis "Workspace V2" — rupa baharu Workspace SEBENAR (23 Okt 2026)
   ============================================================
   ⭐ SATU suis untuk SEMUA tab (arahan user 23 Okt): setiap tab yang siap
   rupa baharunya membaca `aktif` yang sama; tab yang belum siap kekal rupa
   lama walaupun suis hidup. Toggle dipapar di kepala Workspace (sebelah pil
   bahasa) pada tab Generate SAHAJA — tab lain akan memakai baris itu untuk
   kawalan sendiri. Kini hanya tab Generate ada rupa baharu.

   Keputusan user: rupa Generate baharu dibina di Workspace sebenar,
   bersebelahan rupa lama, dan TIDAK boleh sampai kepada pelanggan walaupun
   ter-deploy. Admin menukar lama ⇄ baru dengan toggle dalam tab Generate
   ("aku malas la nk paste2 kat console").

   • Admin SAHAJA (`isAdmin` daripada App.jsx). Pelanggan: sentiasa `false`,
     tiada toggle, tiada bacaan Firestore.
   • Pilihan diingat per-browser (`sesaat_generate_v2`). Storan gagal → rupa lama.
   • Hari lancar (BELUM): tambah suis `config/generate_v2` (corak useUiV39 —
     fail-closed + pengecualian rules `allow read` untuk semua) supaya boleh
     buka/tutup kepada pelanggan tanpa deploy.
   ============================================================ */

import { useState } from 'react';

const KUNCI = 'sesaat_generate_v2';

function bacaPilihan() {
    try { return localStorage.getItem(KUNCI) === '1'; } catch { return false; }
}

export default function useGenerateV2(isAdmin) {
    const [pilih, setPilih] = useState(bacaPilihan);
    const tukar = (hidup) => {
        setPilih(hidup);
        try {
            if (hidup) localStorage.setItem(KUNCI, '1');
            else localStorage.removeItem(KUNCI);
        } catch { /* storan disekat — pilihan hanya untuk sesi ini */ }
    };
    return { aktif: !!isAdmin && pilih, bolehTukar: !!isAdmin, tukar };
}
